import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("table_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e?.config?.url || "";
    const isAuthForm = url.includes("/auth/login") || url.includes("/auth/change-pin");
    if (e?.response?.status === 401 && !isAuthForm) {
      localStorage.removeItem("table_token");
      window.location.href = "/";
    }
    return Promise.reject(e);
  },
);

export const errMsg = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong";
